module.exports = __webpack_public_path__ + "img/block3_img.114f9f9d.png";